if ( !customElements.get( 'kids-support-icons' ) ) {
	customElements.define(
		'kids-support-icons',
		class KidsSupportIcons extends HTMLElement {
			constructor () {
				super();
				this._isOpen = false;
				this._isHiddenByOct8ne = false;
				this._trigger = null;
				this._closeButton = null;
				this._oct8neButton = null;
				this._elevenLabsButton = null;
				this._whatsappLink = null;
				this._oct8neObserver = null;
				this._oct8neInterval = null;

				this._onToggleClick = this._onToggleClick.bind( this );
				this._onCloseClick = this._onCloseClick.bind( this );
				this._onOct8neClick = this._onOct8neClick.bind( this );
				this._onElevenLabsClick = this._onElevenLabsClick.bind( this );
				this._onDocumentPointerDown = this._onDocumentPointerDown.bind( this );
				this._onDocumentClick = this._onDocumentClick.bind( this );
				this._onKeyDown = this._onKeyDown.bind( this );
			}

			connectedCallback () {
				this._trigger = this.querySelector( '[data-action="toggle"]' );
				this._closeButton = this.querySelector( '[data-action="close"]' );
				this._oct8neButton = this.querySelector( '[data-action="oct8ne"]' );
				this._elevenLabsButton = this.querySelector( '[data-action="eleven-labs"]' );
				this._whatsappLink = this.querySelector( '[data-action="whatsapp"]' );

				if ( !this._trigger || !this._closeButton || !this._oct8neButton ) {
					return;
				}

				this._applyWhatsAppUrl();

				this._trigger.addEventListener( 'click', this._onToggleClick );
				this._closeButton.addEventListener( 'click', this._onCloseClick );
				this._oct8neButton.addEventListener( 'click', this._onOct8neClick );
				this._elevenLabsButton?.addEventListener( 'click', this._onElevenLabsClick );

				document.addEventListener( 'pointerdown', this._onDocumentPointerDown, true );
				document.addEventListener( 'click', this._onDocumentClick, true );
				document.addEventListener( 'keydown', this._onKeyDown );
				this._startOct8neWatcher();
				this._syncWithOct8neState();
			}

			disconnectedCallback () {
				this._trigger?.removeEventListener( 'click', this._onToggleClick );
				this._closeButton?.removeEventListener( 'click', this._onCloseClick );
				this._oct8neButton?.removeEventListener( 'click', this._onOct8neClick );
				this._elevenLabsButton?.removeEventListener( 'click', this._onElevenLabsClick );

				document.removeEventListener( 'pointerdown', this._onDocumentPointerDown, true );
				document.removeEventListener( 'click', this._onDocumentClick, true );
				document.removeEventListener( 'keydown', this._onKeyDown );
				this._stopOct8neWatcher();
			}

			open () {
				if ( this._isOpen ) return;

				this._isOpen = true;
				this.classList.add( 'is-open' );
				this._trigger?.setAttribute( 'aria-expanded', 'true' );
				this.querySelector( '.kids-support__actions' )?.setAttribute( 'aria-hidden', 'false' );
			}

			close () {
				if ( !this._isOpen ) return;

				this._isOpen = false;
				this.classList.remove( 'is-open' );
				this._trigger?.setAttribute( 'aria-expanded', 'false' );
				this.querySelector( '.kids-support__actions' )?.setAttribute( 'aria-hidden', 'true' );
			}

			toggle () {
				if ( this._isOpen ) {
					this.close();
				} else {
					this.open();
				}
			}

			_onToggleClick ( event ) {
				event.preventDefault();
				this.toggle();
			}

			_onCloseClick ( event ) {
				event.preventDefault();
				this.close();
			}

			_onOct8neClick ( event ) {
				event.preventDefault();

				const opened = this._openOct8neWidget();
				if ( !opened ) {
					console.warn( 'Kids Support: no se encontró launcher/API de Oct8ne en la página.' );
				}

				this.close();
				window.setTimeout( () => this._syncWithOct8neState(), 250 );
				window.setTimeout( () => this._syncWithOct8neState(), 1000 );
			}

			_onElevenLabsClick ( event ) {
				event.preventDefault();

				const opened = this._openElevenLabsWidget();
				if ( !opened ) {
					console.warn( 'Kids Support: no se encontró launcher/API de ElevenLabs en la página.' );
				}

				this.close();
			}

			_onDocumentPointerDown ( event ) {
				if ( !this._isOpen ) return;
				if ( this.contains( event.target ) ) return;

				this.close();
			}

			_onDocumentClick ( event ) {
				if ( !this._isOct8neLauncherClick( event ) ) return;

				this.close();
				this.classList.add( 'is-hidden-by-oct8ne' );
				this._isHiddenByOct8ne = true;
				window.setTimeout( () => this._syncWithOct8neState(), 120 );
				window.setTimeout( () => this._syncWithOct8neState(), 500 );
			}

			_onKeyDown ( event ) {
				if ( event.key === 'Escape' ) {
					this.close();
				}
			}

			_applyWhatsAppUrl () {
				if ( !this._whatsappLink ) return;

				const whatsappUrl = ( this.dataset.whatsappUrl || this._whatsappLink.getAttribute( 'href' ) || '' ).trim();
				const isPlaceholder = whatsappUrl.includes( 'XXXXXXXXXXX' );
				const isValid = this._isValidWhatsAppUrl( whatsappUrl );

				if ( !whatsappUrl || isPlaceholder || !isValid ) {
					this._whatsappLink.hidden = true;
					return;
				}

				this._whatsappLink.href = whatsappUrl;
				this._whatsappLink.hidden = false;
			}

			_isValidWhatsAppUrl ( urlValue ) {
				try {
					const url = new URL( urlValue, window.location.origin );
					const protocol = url.protocol.toLowerCase();
					const host = url.hostname.toLowerCase();

					if ( protocol !== 'https:' && protocol !== 'http:' ) {
						return false;
					}

					return host === 'wa.me' || host === 'api.whatsapp.com' || host === 'www.whatsapp.com' || host === 'whatsapp.com';
				} catch ( error ) {
					return false;
				}
			}

			_openOct8neWidget () {
				const oct8neApiCandidates = [
					() => window.Oct8ne?.open?.(),
					() => window.oct8ne?.open?.(),
					() => window.OCT8NE?.open?.(),
					() => window.Oct8ne?.chat?.open?.(),
					() => window.oct8neChat?.open?.(),
					() => window.$OCT8NE?.openChat?.(),
					() => window.$_OCT8NE?.openChat?.(),
					() => window.Oct8neLauncher?.open?.(),
					() => window.Oct8neSDK?.open?.()
				];

				for ( const openCandidate of oct8neApiCandidates ) {
					try {
						const result = openCandidate();
						if ( typeof result !== 'undefined' ) {
							return true;
						}
					} catch ( error ) {
						// Fall through to next candidate.
					}
				}

				const launcherSelectors = this._getOct8neLauncherSelectors();

				for ( const selector of launcherSelectors ) {
					const launcher = document.querySelector( selector );
					if ( launcher instanceof HTMLElement ) {
						launcher.click();
						return true;
					}
				}

				return false;
			}

			_getOct8neLauncherSelectors () {
				return [
					'#oct8ne-launcher',
					'.oct8ne-launcher',
					'[id*="oct8ne"][class*="launcher"]',
					'[class*="oct8ne-launcher"]',
					'[class*="oct8ne_button"]',
					'[aria-label*="Oct8ne" i]',
					'[data-oct8ne-launcher]'
				];
			}

			_isOct8neLauncherClick ( event ) {
				const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
				const launcherSelectors = this._getOct8neLauncherSelectors();

				for ( const candidate of path ) {
					if ( !( candidate instanceof Element ) ) continue;
					if ( candidate === this || this.contains( candidate ) ) continue;

					for ( const selector of launcherSelectors ) {
						if ( candidate.matches( selector ) ) {
							return true;
						}
					}
				}

				return false;
			}

			_openElevenLabsWidget () {
				const elevenLabsApiCandidates = [
					() => window.ElevenLabs?.open?.(),
					() => window.elevenlabs?.open?.(),
					() => window.ElevenLabsWidget?.open?.(),
					() => window.elevenlabsWidget?.open?.(),
					() => window.ElevenLabsConvAI?.open?.(),
					() => window.elevenlabsConvAI?.open?.()
				];

				for ( const openCandidate of elevenLabsApiCandidates ) {
					try {
						const result = openCandidate();
						if ( typeof result !== 'undefined' ) {
							return true;
						}
					} catch ( error ) {
						// Fall through to next candidate.
					}
				}

				const launcherSelectors = [
					'[id*="eleven" i][class*="launcher" i]',
					'[class*="eleven" i][class*="launcher" i]',
					'[data-elevenlabs-launcher]',
					'[aria-label*="ElevenLabs" i]',
					'elevenlabs-convai'
				];

				for ( const selector of launcherSelectors ) {
					const launcher = document.querySelector( selector );
					if ( launcher instanceof HTMLElement ) {
						launcher.click();
						return true;
					}
				}

				return false;
			}

			_startOct8neWatcher () {
				this._stopOct8neWatcher();

				this._oct8neInterval = window.setInterval( () => this._syncWithOct8neState(), 700 );

				if ( typeof MutationObserver !== 'undefined' && document.documentElement ) {
					this._oct8neObserver = new MutationObserver( () => this._syncWithOct8neState() );
					this._oct8neObserver.observe( document.documentElement, {
						subtree: true,
						childList: true,
						attributes: true,
						attributeFilter: [ 'class', 'style', 'aria-expanded', 'aria-hidden', 'open' ]
					} );
				}
			}

			_stopOct8neWatcher () {
				if ( this._oct8neInterval ) {
					window.clearInterval( this._oct8neInterval );
					this._oct8neInterval = null;
				}

				if ( this._oct8neObserver ) {
					this._oct8neObserver.disconnect();
					this._oct8neObserver = null;
				}
			}

			_syncWithOct8neState () {
				const oct8neOpen = this._isOct8neOpen();

				if ( oct8neOpen === this._isHiddenByOct8ne ) {
					return;
				}

				this._isHiddenByOct8ne = oct8neOpen;

				if ( oct8neOpen ) {
					this.close();
					this.classList.add( 'is-hidden-by-oct8ne' );
				} else {
					this.classList.remove( 'is-hidden-by-oct8ne' );
				}
			}

			_isOct8neOpen () {
				const candidates = document.querySelectorAll(
					'[id*="oct8ne" i], [class*="oct8ne" i], iframe[src*="oct8ne" i]'
				);

				for ( const element of candidates ) {
					if ( !( element instanceof HTMLElement ) ) continue;
					if ( !this._isVisibleElement( element ) ) continue;

					const className = ( element.className || '' ).toString().toLowerCase();
					const id = ( element.id || '' ).toLowerCase();
					const ariaExpanded = element.getAttribute( 'aria-expanded' );
					const ariaHidden = element.getAttribute( 'aria-hidden' );
					const isDialogLike = element.getAttribute( 'role' ) === 'dialog' || element.tagName === 'DIALOG';
					const isIframe = element.tagName === 'IFRAME';
					const rect = element.getBoundingClientRect();
					const area = rect.width * rect.height;

					if ( ariaExpanded === 'true' || ( ariaHidden === 'false' && isDialogLike ) ) {
						return true;
					}

					if (
						className.includes( 'open' ) ||
						className.includes( 'active' ) ||
						className.includes( 'expanded' ) ||
						id.includes( 'chat-open' )
					) {
						return true;
					}

					if ( isIframe && area > 20000 ) {
						return true;
					}
				}

				return false;
			}

			_isVisibleElement ( element ) {
				const style = window.getComputedStyle( element );
				if ( style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0' ) {
					return false;
				}

				const rect = element.getBoundingClientRect();
				return rect.width > 0 && rect.height > 0;
			}
		}
	);
}
